import React from "react";

export default function ComplaintofSexualHarassment(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Complaint of Sexual Harassment
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Making the Complaint
          </h2>

          <ul className="space-y-4 mb-4">
            <li className="flex items-center">
              <span className="text-yellow-500 mr-2">●</span>
              <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
                <span className="text-gray-700 block mb-4">
                  Any complainant may make, in writing, a complaint of sexual
                  harassment at workplace to the Presiding Officer of the ICC or
                  any other member of ICC or to Dr. Abhijeet Barse, CEO, SS
                  (abhijeet.barse@slumsoccer.org) who shall forward the
                  complaint to the Presiding Officer of ICC.
                </span>
                <span className="text-gray-700 block mb-4">
                  Where any of the members of ICC are involved, the complaint
                  may be made in writing directly to CEO, SS who will take
                  necessary action to keep the ICC member away from proceedings
                  of ICC and, if required, provide a replacement member in ICC.
                </span>
                <span className="text-gray-700 block mb-1">
                  In the event, the complaint of sexual harassment is against
                  the CEO, SS, the Aggrieved Person should make a complaint in
                  writing to the “Local Complaints Committee” constituted in
                  accordance with law.
                </span>
              </div>
            </li>
            <li className="flex items-center">
              <span className="text-yellow-500 mr-2">●</span>
              <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
                <span className="text-gray-700 block mb-4">
                  The complaint shall be made within a period of 3 months from
                  the date of incident and in case of a series of incidents,
                  within a period of 3 months from the date of last incident:
                </span>
                <span className="text-gray-700 block mb-4">
                  Provided that where such complaint cannot be made in writing,
                  the Presiding Officer or any member of the ICC shall render
                  all reasonable assistance to the aggrieved person for making
                  the complaint in writing.
                </span>
                <span className="text-gray-700 block mb-1">
                  Provided further that the ICC may, for the reasons to be
                  recorded in writing, extend the time limit not exceeding 3
                  months, if it is satisfied that the circumstances were such
                  which prevented the person from filing a complaint within the
                  said period.
                </span>
              </div>
            </li>
            <li className="flex items-center">
              <span className="text-yellow-500 mr-2">●</span>
              <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
                <span className="text-gray-700 block mb-4">
                  Where the complainant is unable to make a complaint any
                  relative, friend, co-worker, or any person having the
                  knowledge of the incident may make a complaint to the ICC or
                  Mr.Abhijeet Barse(CEO, SS) (a) with the written consent of the
                  complainant in case of her physical incapacity; (b) with the
                  written consent of her guardian/ carer in case of her mental
                  incapacity; (c) with the written consent of her legal heir in
                  case of her death
                </span>
              </div>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            What should the complaint contain?
          </h2>
          <span className="text-gray-700 block mb-1">
            In order to enable ICC to take appropriate and timely action, the
            complaint should contain a detailed description of the incident(s),
            including date, time, place, respondent’s name, working relationship
            (if any) with respondent, list of witnesses (if any) alongwith all
            available documentary and electronic evidences in support of the
            complaint.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Receiving the Complaint
          </h2>
          <ul className="space-y-4 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                On receipt of the detailed complaint, the Presiding Officer of
                the ICC shall, in normal course, acknowledge receipt of
                complaint to the complainant within 7 days of receiving the
                complaint. A complete copy of the complaint and other supporting
                documents, including evidence and statements of witnesses shall
                also be sent to the respondent within 7 days of receiving the
                complaint.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Upon receiving a copy of the complaint, the respondent shall
                file his/her detailed reply to the complaint, along with
                supporting documents, list of witnesses etc. within a period of
                10 days of receipt of the complaint by him/her. A complete copy
                of the reply along with the supporting documents, including
                evidence and statements of witnesses provided by the respondent
                shall be sent to the complainant within 7 days of receiving the
                reply from respondent. At this stage, the ICC may ascertain from
                the complainant whether she would like to adopt the conciliation
                route to resolve her complaint. The complainant shall indicate
                her option to ICC within 7 days of receipt of response of the
                respondent by her.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Resolution through Conciliation
          </h2>
          <ul className="space-y-4 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Before initiating the inquiry, the ICC may, in the event of the
                complainant opting for conciliation, take steps to settle the
                matter between her and respondent through conciliation. In this
                regard, the Presiding Officer of ICC shall explore enabling ways
                to settle the complaint through conciliation. This can include
                counselling, educating, orienting, or warning the respondent to
                promptly stop the unwelcome behaviour or appointing a neutral
                person acceptable to both parties to act as a conciliator
                between the parties to resolve the complaint through
                conciliation. The conciliation process shall be completed within
                a reasonable period of time, say within 15 days of receipt of
                response of the complainant opting for conciliation.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                It should be made clear to all parties that conciliation in
                itself doesn’t necessarily mean acceptance of complaint by the
                respondent. It is a practical mechanism through which issues are
                resolved or misunderstandings cleared.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                No monetary settlement shall be made a basis of conciliation.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                In case a settlement is arrived at, the ICC will record & report
                the same to the CEO, SS for taking appropriate action. The ICC
                shall provide copies of the settlement to complainant &
                respondent. Once the action is implemented, no further inquiry
                shall be conducted by ICC.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                If conciliation fails and/or no settlement is reached between
                the parties, the ICC shall proceed to conduct a formal inquiry
                into the complaint within 7 days of receiving the report of
                failure of conciliation.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                If the respondent and/or employer fail to implement the terms of
                the settlement within a reasonable period, the complainant may
                request the ICC to conduct a formal inquiry into the complaint.
                The ICC shall proceed with making a formal inquiry within 7 days
                of receiving such notice/ request.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Conducting an Inquiry into the Complaint
          </h2>
          <ul className="space-y-4 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The ICC shall conduct a prompt, thorough and impartial
                investigation of a complaint as necessary and appropriate, in
                accordance with the principles of natural justice.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <div>
                <span className="text-gray-700 block mb-3">
                  Upon receipt of a complaint, the ICC would act as the Inquiry
                  Committee to examine, enquire, investigate and prepare a
                  report. The quorum of the Inquiry Committee would be the
                  Presiding Officer and at least two members of ICC (including
                  the NGO member). The Inquiry Committee shall be notified to
                  the parties prior to commencement of the investigation and
                  hearings, and will not be changed throughout the process.
                  Majority of the members in any meeting of the Inquiry
                  Committee shall be women. The Inquiry Committee shall be
                  subject to the following rules:{" "}
                </span>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">
                      Members must recuse themselves from the process if a
                      conflict of interest or prejudice concerning the matter is
                      demonstrated.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">
                      Any member of the ICC, complainant or respondent, with
                      reasonable knowledge of the existence of a member’s
                      conflict of interest or prejudice may submit an
                      application for change of Inquiry Committee.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">
                      CEO/SS in consultation with the remainder of the ICC will
                      decide on the request for change of Inquiry Committee.
                    </span>
                  </li>
                </ul>
              </div>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Both parties shall be given the opportunity to appear before the
                Inquiry Committee and present their case and/or submit names of
                any witnesses or documentary evidence substantiating their case.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The Inquiry Committee shall have the powers to (i) call upon any
                such witnesses and record their statements (ii) summon and
                enforce the attendance of any person and examine them on oath
                (iii) discover/ call for production of
                documents/records/files/data. The proceedings shall be conducted
                in such language as may be familiar to the aggrieved person and
                the respondent.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Except exceptional circumstances, the complainant and respondent
                should inform the Inquiry Committee in writing at least 24 hours
                in advance of the hearing the names of any witnesses he/she
                wishes to testify. Any information shared during a hearing is
                confidential.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The complainant or respondent shall not question each other or
                other witnesses directly but may raise questions to be asked of
                that party through the Inquiry Committee, which will determine
                whether to ask them.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The minutes of the proceedings shall be recorded in English and
                where the aggrieved person or the respondent is not conversant
                with English, in addition, in such language as may be familiar
                to them.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                If a party is not present for more than 3 consecutive hearings,
                without sufficient cause to the satisfaction of the Inquiry
                Committee, the Inquiry Committee may, after giving that party a
                notice of 10 days, give an ex parte decision on the complaint.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The Inquiry Committee shall complete its investigation within 90
                days.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The Inquiry Report of the Inquiry Committee, including its
                decision and recommendations, and reasons for arriving at such
                decision, shall be submitted communicated to CEO,SS, the
                complainant and the respondent, in writing, at the earliest and
                in any case within 10 days of completion of the investigation.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                If the allegations against the respondent are proved to be true,
                the Inquiry Committee shall also recommend the penalties or
                corrective action that may be taken against him/her to the CEO,
                SS.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                CEO,SS shall act on the recommendation of the Inquiry Committee
                within a period of 60 days from the date of the receipt of the
                Inquiry Report, unless an appeal against the findings is filed
                within that period by either party.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Interim Relief
          </h2>
          <span className="text-gray-700 block mb-3">
            During the pendency of the inquiry, on a written request made by the
            complainant, the Inquiry Committee may recommend to the employer to:
          </span>
          <ul className="space-y-4 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Transfer the complainant or the respondent to any other workplace; or 
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Grant leave to the complainant, for a period of upto 3 months, in addition to the leave 
she would be otherwise entitled; or  
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Grant such other relief to the complainant as may be appropriate. 
              </span>
            </li>
          </ul>
          <span className="text-gray-700 block mb-3">
            Once the recommendations of interim relief are implemented, the employer shall 
implement the recommendations and send the report of such implementation to ICC.  
          </span>
        </div>
      </div>
    </div>
  );
}
